export default __webpack_public_path__ + "static/media/logocomline.d9842cff.png";